module.exports = __webpack_public_path__ + "bbbf97b387110117b671d787ebd378d0.jpg";